import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50">
      <div className="container-section">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* About Column */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-gray-900">
              Dr. Danijel <span className="text-medical-600">Novak</span>
            </h3>
            <p className="text-gray-600">
              Specialist plastične, rekonstruktivne in estetske kirurgije z bogatimi izkušnjami in strastjo do detajlov.
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://www.instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-medical-100 flex items-center justify-center text-medical-600 hover:bg-medical-200 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-medical-100 flex items-center justify-center text-medical-600 hover:bg-medical-200 transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-gray-900">Hitre povezave</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/o-nas" className="text-gray-600 hover:text-medical-600 transition-colors">O nas</Link>
              </li>
              <li>
                <Link to="/storitve" className="text-gray-600 hover:text-medical-600 transition-colors">Storitve</Link>
              </li>
              <li>
                <Link to="/cenik" className="text-gray-600 hover:text-medical-600 transition-colors">Cenik</Link>
              </li>
              <li>
                <Link to="/galerija" className="text-gray-600 hover:text-medical-600 transition-colors">Galerija</Link>
              </li>
              <li>
                <Link to="/nasveti" className="text-gray-600 hover:text-medical-600 transition-colors">Nasveti</Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-600 hover:text-medical-600 transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-gray-900">Kontaktne informacije</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="text-medical-500 mr-3 mt-1 flex-shrink-0" size={18} />
                <div>
                  <p className="font-medium text-gray-800">Ljubljana:</p>
                  <p className="text-gray-600">Rožna ulica 7, 1000 Ljubljana</p>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin className="text-medical-500 mr-3 mt-1 flex-shrink-0" size={18} />
                <div>
                  <p className="font-medium text-gray-800">Celje:</p>
                  <p className="text-gray-600">Bežigrajska cesta 12, 3000 Celje</p>
                </div>
              </li>
              <li className="flex items-center">
                <Phone className="text-medical-500 mr-3 flex-shrink-0" size={18} />
                <a href="tel:+38641123456" className="text-gray-600 hover:text-medical-600">+386 41 123 456</a>
              </li>
              <li className="flex items-center">
                <Mail className="text-medical-500 mr-3 flex-shrink-0" size={18} />
                <a href="mailto:info@danijelnovak.si" className="text-gray-600 hover:text-medical-600">info@danijelnovak.si</a>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-gray-900">Delovni čas</h4>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Clock className="text-medical-500 mr-3 flex-shrink-0" size={18} />
                <div>
                  <p className="font-medium text-gray-800">Pon - Pet</p>
                  <p className="text-gray-600">8:00 - 19:00</p>
                </div>
              </li>
              <li className="flex items-center">
                <Clock className="text-medical-500 mr-3 flex-shrink-0" size={18} />
                <div>
                  <p className="font-medium text-gray-800">Sob</p>
                  <p className="text-gray-600">8:00 - 14:00</p>
                </div>
              </li>
              <li className="flex items-center">
                <Clock className="text-medical-500 mr-3 flex-shrink-0" size={18} />
                <div>
                  <p className="font-medium text-gray-800">Ned in prazniki</p>
                  <p className="text-gray-600">Zaprto</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <p className="text-gray-500 text-sm">
              © {currentYear} Dr. Danijel Novak. Vse pravice pridržane.
            </p>
            <div className="flex space-x-4 md:justify-end text-sm text-gray-500">
              <Link to="/zasebnost" className="hover:text-medical-600 transition-colors">
                Politika zasebnosti
              </Link>
              <Link to="/pogoji" className="hover:text-medical-600 transition-colors">
                Pogoji uporabe
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;